const capitalize = value => value.toUpperCase();

export default capitalize;
